import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import { Icons, SecondaryButton } from '../../../components';
import sellersImg from '../../../assets/seller-img.png';
import sellerStepImg from '../../../assets/seller-step.png';
import sellerFee from '../../../assets/seller-fee.png';

import SectionFAQ from './SectionFAQ';

function SectionBuyers(props) {
  const { intl } = props;
  const featureItems = [
    {
      icon: 'browseMarketplace',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.browseMarketplace.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.browseMarketplace.description' }),
    },
    {
      icon: 'filterBySize',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.filterBySize.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.filterBySize.description' }),
    },
    {
      icon: 'makeAnOffer',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.makeAnOffer.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.makeAnOffer.description' }),
    },
    {
      icon: 'checkout',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.checkout.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.checkout.description' }),
    },
    {
      icon: 'trackOrder',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.trackOrder.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.trackOrder.description' }),
    },
    {
      icon: 'receiveConfirm',
      title: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.receiveConfirm.title' }),
      description: intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.receiveConfirm.description' }),
    },
  ];
  return (
    <div className={css.buyersContainer}>
      <div className={css.fixedWidthContainer}>
        <h1>{intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.title' })}</h1>
        <div className={css.buyersSteps}>
          {intl.formatMessage({ id: 'HowItWorksPage.SectionBuyers.steps' })}
        </div>
        <div className={css.buyersContent}>
          {featureItems.map(({ title, description, icon }, index) => (
            <div key={index} className={css.categoryItem}>
              <Icons name={icon} />
              <h3>{title}</h3>
              <p>{description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

SectionBuyers.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionBuyers;